import * as THREE from 'three'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Resources from './Utils/Resources.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import sources from './sources.js'

let instance = null

/**
 * Experience
 * Singleton root class. Receives the canvas element and bootstraps every subsystem.
 * Owns the Three.js Scene and coordinates the update/resize propagation chain.
 */
export default class Experience {
    constructor(canvas) {
        // Singleton
        if (instance) return instance
        instance = this

        this.canvas = canvas
        this.scene = new THREE.Scene()

        this.sizes = new Sizes()
        this.time = new Time()
        this.resources = new Resources(sources)
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.world = new World()

        this.sizes.on('resize', () => this.resize())
        this.time.on('tick', () => this.update())
    }

    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        this.camera.update()
        this.renderer.update()
    }
}
